import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, responsivefy} from '../functions'
import Sankey from "d3-sankey/src/sankey";
import {sankeyLinkHorizontal} from "d3-sankey";

export default function (chart, divId, vizName,resData, filterParam) {

    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName,filterParam)


    var svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width + chart.margin.left + chart.margin.right)
        .attr("height", chart.height - chart.margin.top + chart.margin.bottom)
        .call(responsivefy)
        .append("g")
        .attr("transform", "translate(" + chart.margin.left + "," + chart.margin.top + ")");

    var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);

    // Set the sankey diagram properties
    var sankey = Sankey()
        .nodeWidth(36)
        .nodePadding(40)
        .size([chart.width, chart.height])
        .nodeSort(null);

    var path = sankey.links();

    console.log(path)

    // axios.post(url, filterParam).then(res => {

        let data =resData

        console.log("sankey", data)
        //set up graph in same style as original example but empty
        var sankeydata = {"nodes": [], "links": []};

        var keys = Object.keys(data?.[0] || {}); //get the headers for the data
        keys.splice(keys.indexOf('metric1'), 1)//remove the IDs key

        data.forEach(function (d) {
            keys.forEach(function (key, i) {
                if (d[key] != null) {
                    adduniquenodes(d[key]);
                } //add node if not "none"
                var c = 1; //checks next column
                if (d[keys[i + c]] != undefined && d[key] !== null) {
                    while (d[keys[i + c]] === null) {
                        c = c + 1;     //jump to next column if "none" found in the column next
                    }
                    sankeydata.links.push({
                        "source": d[key],
                        "target": d[keys[i + c]],
                        "value": countvalues(key, d[key], keys[i + c], d[keys[i + c]])
                    });
                }
            })
        });

        function adduniquenodes(value) {
            if (sankeydata.nodes.indexOf(value) === -1) {
                sankeydata.nodes.push(value);
            }
        }

        function countvalues(sourcekey, source, targetkey, target) {
            var c = 0;
            data.forEach(function (d) {
                if (d[sourcekey] === source && d[targetkey] === target) {
                    c++;
                }

            });
            return c;
        }

        // loop through each link replacing the text with its index from node
        sankeydata.links.forEach(function (d, i) {
            sankeydata.links[i].source = sankeydata.nodes.indexOf(sankeydata.links[i].source);
            sankeydata.links[i].target = sankeydata.nodes.indexOf(sankeydata.links[i].target);
        });

        //now loop through each nodes to make nodes an array of objects
        // rather than an array of strings
        sankeydata.nodes.forEach(function (d, i) {
            sankeydata.nodes[i] = {"name": d};
        });

        /* sankeydata.nodes(graph.nodes)
                  .links(graph.links)
                  .layout(32);*/

        var graph = sankey(sankeydata);


        console.log(graph);
        // // add in the links
        var link = svg.append("g").selectAll(".link")
            .data(graph.links)
            .enter().append("path")
            .attr("class", "sank-link")
            .attr("d", sankeyLinkHorizontal())
            .attr("stroke-width", function (d) {
                return Math.max(1, d.width)
            })
            .style("stroke", function (d) {
                return metric1ColorScale(d.source.name)
            })


        // add the link tles
        link.append("title")
            .text(function (d) {
                return d.source.name + " → " + d.target.name + "\n"
                    + chart.y1MetricTooltip + colonAnnotation + d.value
            });

        // add in the nodes
        var node = svg.append("g").selectAll(".node")
            .data(graph.nodes)
            .enter().append("g")
            .attr("class", "sank-node")


        // add the rectangles for the nodes
        node.append("rect")
            .attr("x", function (d) {
                return d.x0;
            })
            .attr("y", function (d) {
                return d.y0;
            })
            .attr("height", function (d) {
                return d.y1 - d.y0;
            })
            .attr("width", sankey.nodeWidth())
            .style("fill", function (d) {
                return d.metric1ColorScale = metric1ColorScale(d.name);
            })
            //   .style("fill","blue")
            .style("stroke", function (d) {
                return d3.rgb(d.metric1ColorScale).darker(2);
            })

        node.append("title")
            .text(function (d) {
                return d.name
            });


        // add in the title for the nodes
        node.append("text")
            .attr("x", function (d) {
                return d.x0 - 6;
            })
            .attr("y", function (d) {
                return (d.y1 + d.y0) / 2;
            })
            .attr("dy", ".35em")
            .attr("text-anchor", "end")
            .attr("transform", null)
            .text(function (d) {
                return d.name;
            })
            .filter(function (d) {
                return d.x0 < chart.width / 2;
            })
            .attr("x", function (d) {
                return d.x1 + 6;
            })
            .attr("text-anchor", "start");
    // });

}
